import { Component, PLATFORM_ID, Injectable, Injector, Inject, enableProdMode } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Router, NavigationEnd } from '@angular/router';

enableProdMode()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    test_var: any;
    title = 'app';

    constructor(private injector: Injector, @Inject(PLATFORM_ID) private platform_id: Object, private router: Router) {

        const $_: AppComponent = this;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (isPlatformBrowser($_.platform_id)) {

                    (<any>window).ga('set', 'page', event.urlAfterRedirects);
                    (<any>window).ga('send', 'pageview');                    
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts